export default class HeroVideo {
    constructor(component) {
        this.component = component;
        this.image = document.querySelector('[data-video-image]');
        this.mobileActive = window.matchMedia('(max-width: 1024px)').matches;
        this.previousMobileActive = this.mobileActive;
        this.videoUrls = {
            mp4: this.component.getAttribute('data-video-mp4'),
            webm: this.component.getAttribute('data-video-webm'),
            mobileMp4: this.component.getAttribute('data-video-mobile-mp4'),
            mobileWebm: this.component.getAttribute('data-video-mobile-webm'),
        };

        this.button = this.component.parentNode.querySelector('[data-hero-video-button]');

        window.addEventListener('resize', this.handleWindowResize.bind(this));

        this.setupButtonListener();
        this.activateVideoElement();
        this.initIntersectionObserver();
    }

    pauseVideo() {
        this.component.pause();
        this.button.classList.remove('is-playing');
    }

    playVideo() {
        this.component.play();
        this.button.classList.add('is-playing');
        this.image.classList.add('d-none');
    }

    updateVideoElement(mobile) {
        this.component.innerHTML = '';

        if (mobile) {
            if (this.videoUrls.mobileMp4)
                this.component.innerHTML += `<source src="${this.videoUrls.mobileMp4}" type="video/mp4">`;
            if (this.videoUrls.mobileWebm)
                this.component.innerHTML += `<source src="${this.videoUrls.mobileWebm}" type="video/webm">`;
            this.image.style = 'z-index: 1';
            this.image.classList.remove('d-none');
            this.pauseVideo();
        } else {
            if (this.videoUrls.mp4)
                this.component.innerHTML += `<source src="${this.videoUrls.mp4}" type="video/mp4">`;
            if (this.videoUrls.webm)
                this.component.innerHTML += `<source src="${this.videoUrls.webm}" type="video/webm">`;
            this.image.style = 'z-index: 0';
            this.playVideo();
        }
    }

    handleWindowResize() {
        this.mobileActive = window.matchMedia('(max-width: 1024px)').matches;

        if (this.mobileActive !== this.previousMobileActive) {
            this.updateVideoElement(this.mobileActive);
            this.previousMobileActive = this.mobileActive;
        }
    }

    setupButtonListener() {
        if (this.button) {
            const root = this;

            this.button.addEventListener('click', () => {
                // Ensure the video is loaded and ready to play
                if (root.component.readyState < 3) {
                    root.updateVideoElement(root.mobileActive);
                }

                if (
                    root.component.currentTime > 0 &&
                    !root.component.paused &&
                    !root.component.ended
                ) {
                    this.pauseVideo();
                } else if (root.component.currentTime > 0 && root.component.paused) {
                    this.playVideo();
                } else {
                    root.updateVideoElement(root.mobileActive);
                    root.component.load(); // Explicitly load the video
                    this.playVideo();
                }
            });
        }
    }

    activateVideoElement() {
        this.component.style.display = 'block';

        // Autoplay on desktop
        if (!this.mobileActive) {
            this.playVideo();
        } else {
            this.image.style = 'z-index: 1';
        }
    }

    initIntersectionObserver() {
        const options = {
            root: null, // Null means that the viewport is used as the observer
            threshold: 0.5, // Trigger if at least 50% of the element is visible
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) {
                    // Pause the video if the component is not in view
                    this.pauseVideo();
                }
            });
        }, options);

        observer.observe(this.component); // Start observing
    }
}
